import { ROUTES } from "@/constants/routes";

import { getEventDetailsRouterStateFromPathname } from "../router-states/events/event-details";
import { useNavigateWithRouterState } from "./useNavigateWithRouterState";

/**
 * Navigate to `/events/:eventId`, automatically attaching `EventItemsRouterState`
 * when the current page is a known list route (dashboard, all-activity, or a
 * watch detail page). No state is attached when navigating from any other page.
 *
 * Prefer `getLinkProps` for `Button`/`AriaLink` with `href` so react-aria's
 * `RouterProvider` receives the same `state` (plain `onClick` is bypassed).
 */
export function useNavigateToEventDetails() {
	return useNavigateWithRouterState({
		buildState: buildEventDetailsState,
		buildTo: buildEventDetailsTo,
	});
}

function buildEventDetailsState(pathname: string, _eventId: string) {
	return getEventDetailsRouterStateFromPathname(pathname);
}

function buildEventDetailsTo(eventId: string) {
	return `${ROUTES.EVENTS}/${eventId}`;
}
